"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StackWrapBox = _interopRequireDefault(require("./StackWrapBox"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _ViewportProvider = require("../ViewportProvider");
var _getStackedContent = _interopRequireDefault(require("./getStackedContent"));
var _common = require("./common");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);

/**
 * The primary implementation of StackWrap.
 *
 * This is not intended to be used directly. It will automatically be used instead of StackWrap if:
 *
 * - On web, and,
 * - On a browser that supports CSS `gap` (most browser versions from 2020 onwards), and,
 * - The `space` between items is the same as the `gap` between wrapped rows (this is the
 *   default if `gap` prop is undefined)
 */
const StackWrapGap = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    space = 1,
    tokens,
    variant,
    direction: directionProp = 'row',
    children,
    tag,
    accessibilityRole,
    ...rest
  } = _ref;
  const viewport = (0, _ViewportProvider.useViewport)();
  const direction = (0, _utils.useResponsiveProp)(directionProp, 'row');
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('StackView', tokens, variant, {
    viewport
  });
  const flexStyles = (0, _common.selectFlexStyles)(themeTokens);
  const selectedProps = selectProps({
    accessibilityRole,
    ...(0, _utils.getA11yPropsFromHtmlTag)(tag, accessibilityRole),
    ...rest
  });
  const size = (0, _utils.useSpacingScale)(space);
  const gapStyle = {
    gap: size
  };
  const content = (0, _getStackedContent.default)(children, {
    direction,
    space: 0
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ref: ref,
    ...selectedProps,
    style: [flexStyles, _common.staticStyles.wrap, _common.staticStyles[direction], gapStyle],
    children: content
  });
});
StackWrapGap.displayName = 'StackWrapGap';
StackWrapGap.propTypes = _StackWrapBox.default.propTypes;
var _default = exports.default = StackWrapGap;